import type { InventoryListingConfig } from "@dealer-center/ddc-pages-inventory-config-interface";
import { SaveModal } from "./SaveModal";
import styled from "styled-components";
import { footerHeight } from "@dealer-center/core-custom-components";

export interface ButtonBarInterface {
  existingConfig: InventoryListingConfig;
  curentConfig: InventoryListingConfig;
  setCurrentConfig: (value: InventoryListingConfig) => void;
}

const StyledButtonBar = styled.div`
  display: flex;
  justify-content: right;
  & > button {
    margin-left: 1rem;
  }
  position: fixed;
  bottom: ${footerHeight}px;
  background-color: rgba(255, 255, 255, 0.8);
  left: 0;
  right: 0;
  padding: 11px 96px 11px 0;
  border: 1px solid #555555;
`;

export const ButtonBar = () => {
  return (
    <StyledButtonBar>
      <SaveModal />
    </StyledButtonBar>
  );
};
